// Actions
export const FEATURE_FLAGS__GET_FLAGS = 'FEATURE_FLAGS__GET_FLAGS';
export const FEATURE_FLAGS__REGISTER_EXPOSURE = 'FEATURE_FLAGS__REGISTER_EXPOSURE';
// Mutations
export const FEATURE_FLAGS__MUTATE_FLAGS = 'FEATURE_FLAGS__MUTATE_FLAGS';
// Getters
export const FEATURE_FLAGS__ALL_FLAGS = 'FEATURE_FLAGS__ALL_FLAGS';
